import React from "react";
import { Modal, Form, Input, Select } from "antd";
import { AutoResizeTextArea } from "../../../components/AutoResizeTextArea";

import styles from "./styles/AdReportForm.scss";
import { AdReportReason } from "../../../models/enums";
import { requiredField } from "../../../models/formValidator";
import { submitFormData } from "../../../HOCs";
import { reportAd } from "../../../routes/Ad/ad.ducks";

const defaultSettings = {
  form: {
    reason: {
      label: "Razlog prijave",
      field: "reason",
      rules: [requiredField(null, "Unesite razlog")]
    },
    description: {
      label: "Opis",
      field: "description",
      rowCount: 5,
      rules: [
        {
          min: 4,
          max: 200,
          required: true,
          message: "Opis ne može biti dulji od 200 znakova i kraći od 4."
        }
      ]
    },
    submitButton: {
      text: "Prijavi"
    },
    cancelButton: {
      text: "Odustani"
    }
  },
  modal: {
    title: "Prijavi oglas"
  }
};

// eslint-disable-next-line max-lines-per-function
function AdReportForm({
  visible,
  form,
  settings,
  onSubmit,
  onCreate,
  onCancel
}) {
  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleCreate = () => {
    form.validateFields(async (err: any, values: any) => {
      if (err) {
        return;
      }

      await onCreate(values, onSubmit);

      form.resetFields();
    });
  };

  const getPopupContainer = (trigger) => trigger.parentNode ;

  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      onOk={handleCreate}
      okText={settings.form.submitButton.text}
      cancelText={settings.form.cancelButton.text}
      className={styles.modal}
    >
      <div className={styles.title}>{settings.modal.title}</div>
      <Form layout="vertical" className={styles.form}>
        <span className="control-title required">
          {settings.form.reason.label}
        </span>
        <Form.Item>
          {form.getFieldDecorator(settings.form.reason.field, {
            rules: settings.form.reason.rules
          })(
            <Select getPopupContainer={getPopupContainer} placeholder={"Odaberite"}>
              {AdReportReason.map(option => (
                <Select.Option
                  key={option.value}
                  value={option.value}
                  title={option.name}
                >
                  {option.name}
                </Select.Option>
              ))}
            </Select>
          )}
        </Form.Item>
        <span className="control-title required">
          {settings.form.description.label}
        </span>
        <Form.Item>
          {form.getFieldDecorator(settings.form.description.field, {
            rules: settings.form.description.rules
          })(
            <AutoResizeTextArea
              rows={settings.form.description.rowCount}
              className={styles.saveName}
            />
          )}
        </Form.Item>
      </Form>
    </Modal>
  );
}

AdReportForm.defaultProps = {
  settings: defaultSettings,
  visible: false
};

export default submitFormData(Form.create()(AdReportForm), reportAd);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/AdReportForm.tsx